import {View} from './view';
import {Translations} from '../config/translations';
import { GiftAmount } from '../config/gift-amount';

export class DonationView extends View {

    donationFormContainer: HTMLElement = document.createElement('form');
    amountChanged = false;
    minDonation = null;
    isBuilder = false;

    renderDonationForm(amount: string, currencySign: string, subscriptionPlan: any[] = [],
            donationFieldOnTop? :boolean, giftAmounts?: GiftAmount[], legacyDonationIntervals?: boolean,
            giftAmountClickCallback?: any, intervalClickCallback?: any, minimumDonation?: any, isBuilder?: boolean) {
        this.donationFormContainer.setAttribute('id', 'donation-form');
        this.donationFormContainer.classList.add('hs-form', 'stacked', 'df-f', 'df-f-donation');

        this.isBuilder = Boolean(isBuilder);

        if (minimumDonation) {
            this.minDonation = minimumDonation;
        }

        const areIntervalButtonsEnabled = this.areIntervalButtonsEnabled(legacyDonationIntervals);
        if (areIntervalButtonsEnabled) {
            this.renderIntervalButtons(this.donationFormContainer, subscriptionPlan);
        }
        this.renderGiftAmountButtons(this.donationFormContainer, 0, giftAmounts ? (giftAmounts.length > 3 ? 3 : giftAmounts.length) : 0,
            giftAmounts, currencySign);
        this.renderAmountField(this.donationFormContainer, amount, currencySign, subscriptionPlan);
        this.renderDonationFormOnTop(this.donationFormContainer, donationFieldOnTop);

        this.setDefaultGiftAmount(giftAmounts);
        if (areIntervalButtonsEnabled) {
            this.setDefaultIntervalButton();
            this.hideIntervalPlansDropdown(this.donationFormContainer);
        } else {
            const donationAmountContainer: HTMLElement = document.querySelector('#donation-amount-container') as HTMLElement;
            if (donationAmountContainer) {
                donationAmountContainer.classList.add('donation-amount-margin-push');
            }
        }

        this.bindIntervalButtonClickEvent(intervalClickCallback);
        this.bindGiftButtonClickEvent(giftAmounts, giftAmountClickCallback);

        const donationField: any = document.querySelector('input#amount');
        if (donationField) {
            donationField.onfocus = () => { this.amountChanged = true; };
        }
    }

    areIntervalButtonsEnabled(legacyDonationIntervals?: boolean) {
        return !legacyDonationIntervals || legacyDonationIntervals === null || legacyDonationIntervals === undefined;
    }

    renderGiftAmountButtons(donationForm: HTMLElement, startIndex: number, endIndex: number,
            giftAmounts?: GiftAmount[], currencySign?: string) {
        if (giftAmounts && giftAmounts.length > 0) {
            let giftAmountButtonsHtml = '';

            switch (giftAmounts.length) {
                case 5:
                    giftAmountButtonsHtml += this.createGiftAmountButtonHtmlRow(giftAmounts, currencySign, 0, 3, 3);
                    giftAmountButtonsHtml += this.createGiftAmountButtonHtmlRow(giftAmounts, currencySign, 3, 5, 3);
                    break;
                case 6:
                    giftAmountButtonsHtml += this.createGiftAmountButtonHtmlRow(giftAmounts, currencySign, 0, 3, 3);
                    giftAmountButtonsHtml += this.createGiftAmountButtonHtmlRow(giftAmounts, currencySign, 3, 6, 3);
                    break;
                default:
                    giftAmountButtonsHtml += this.createGiftAmountButtonHtmlRow(giftAmounts, currencySign);
                    break;
            }

            donationForm.innerHTML +=
                `<div class='field hs-form-field df-field df-field-donation-amount'>
                    <label>
                        <span class="df-f-label" data-label="donation_amount">${Translations.DONATION_AMOUNT}</span>
                    </label>
                </div>
                ${giftAmountButtonsHtml}`;
        }
    }

    createGiftAmountButtonHtmlRow(giftAmounts: GiftAmount[], currencySign?: string, startIndex?: number, endIndex?: number, formColumns?: number) {
        let giftAmountButtonsHtmlRow = '';
        startIndex = startIndex ? startIndex : 0;
        endIndex = endIndex ? endIndex : giftAmounts.length;
        formColumns = formColumns ? formColumns : giftAmounts.length;
        for (let i = startIndex; i < endIndex; i++) {
            const giftAmount: GiftAmount = giftAmounts[i];
            giftAmountButtonsHtmlRow +=
                `<div class='field hs-form-field donation-gift-amount-btn-container df-field'>
                    <div class='input'>
                        <input
                            id='gift-amount-${giftAmount.amount}'
                            type='button'
                            name='gift-amount'
                            class='hs-input gift-amount-btn cursor-pointer df-input ${giftAmount.default ? 'active' : ''}'
                            value='${currencySign ? currencySign + giftAmount.amount : giftAmount.amount}'
                            amount=${giftAmount.amount}
                            default=${giftAmount.default}
                        />
                    </div>
                </div>`;
        }
        return `<fieldset class='gift-amounts form-columns-${formColumns}'>
                    ${giftAmountButtonsHtmlRow}
                </fieldset>`;
    }

    renderAmountField(donationForm: HTMLElement, amount: string, currencySign: string, subscriptionPlan: any[]) {
        donationForm.innerHTML +=
            `<fieldset class='form-columns-2 df-payment-field df-fieldset'>
                <div id='donation-amount-container' class='field hs-form-field df-field'>
                    <label>
                        <span class='df-f-label' data-label="your_donation">${Translations.YOUR_DONATION}</span>
                    </label>
                    <div class="input-group">
                        <div class="input-group-icon">${currencySign.trim()}</div>
                        <div class="input-group-area">
                            <input id='amount' name='amount' class='hs-input amount df-input' type='text' size='20' autocomplete='off' required value='${amount}'/>
                        </div>
                    </div>
                </div>
                <div id='dynamic-plan-interval-container' class="field hs-form-field df-field">
                    <label>
                        <span class="df-f-label" data-label="how_often">${Translations.HOW_OFTEN}</span>
                    </label>
                    <select id='dynamic-plan-interval' class='hs-input dynamic-plan-interval df-select' >
                    </select>
                </div>
            </fieldset>
            <fieldset class='form-columns-1 df-fieldset'>
                <label class='error df-error df-f-label' id='donation-error'></label>
                <label class='df-error' id="minDonation-error" style="display: ${this.isBuilder && this.minDonation ? 'inherit' : 'none'};">
                    <span class="df-f-label" data-label="min_donation">${Translations.MIN_DONATION} ${currencySign.trim()} ${this.formatNumber(this.minDonation || '0')} </span>
                </label>
            </fieldset>`;

        const select = donationForm.querySelector('#dynamic-plan-interval');
        subscriptionPlan.forEach(plan => {
            let option = '<option value=\"' + plan.value + '"' + ' ';
            const selected = plan.selected ? 'selected' : ' ';
            option = option + selected;
            option = option + ' >' + plan.label + '</option>';
            if (select !== null) {
                select.insertAdjacentHTML( 'beforeend', option );
            }
        });
    }

    renderDonationFormOnTop(donationForm: HTMLElement, donationFieldOnTop?: boolean) {
        const container = this.getDFContainer();
        if (donationFieldOnTop !== null && donationFieldOnTop !== undefined && donationFieldOnTop === true) {
            container.insertBefore(donationForm, container.firstChild);
        } else {
            container.appendChild(donationForm);
        }
    }

    renderIntervalButtons(donationForm: HTMLElement, subscriptionPlans: any[]) {
        if (subscriptionPlans.length === 1) {
            return;
        }
        let intervalButtonsHtml = '';
        subscriptionPlans.forEach((subscriptionPlan) => {
            intervalButtonsHtml += this.createIntervalButtonHtml(subscriptionPlan);
        });
        donationForm.innerHTML +=
            `<div class='field hs-form-field df-field'>
                <label>
                    <span class="df-f-label" data-label="donation_frequency">${Translations.DONATION_FREQUENCY}</span>
                </label>
            </div>
            <fieldset id='donation-intervals' class='form-columns-2 df-fieldset'>
                ${intervalButtonsHtml}
            </fieldset>`;
    }

    createIntervalButtonHtml(subscriptionPlan: any) {
        return `<div class='field hs-form-field donation-interval-btn-container df-field'>
                    <div class='input'>
                        <input
                            id='donation-interval-${subscriptionPlan.value}'
                            type='button'
                            name='donation-interval'
                            class='hs-input donation-interval-btn cursor-pointer df-input ${subscriptionPlan.selected ? 'active' : ''}'
                            value='${subscriptionPlan.label}'
                            interval='${subscriptionPlan.value}'
                        />
                    </div>
                </div>`;
    }

    hideIntervalPlansDropdown(donationForm: HTMLElement) {
        const planIntervalElementContainer: HTMLElement = donationForm.querySelector('#dynamic-plan-interval-container') as HTMLElement;
        if (planIntervalElementContainer) {
            planIntervalElementContainer.style.display = 'none';
        }
    }

    setDefaultGiftAmount(giftAmounts?: GiftAmount[]) {
        if (giftAmounts && giftAmounts.length > 1) {
            const defaultGiftAmount = giftAmounts.find((giftAmount: GiftAmount) => giftAmount.default);
            if (!defaultGiftAmount) {
                return;
            }
            const inputAmount = document.getElementById('amount') as HTMLInputElement;
            if (inputAmount) {
                inputAmount.value = `${defaultGiftAmount.amount}`;
                inputAmount.dispatchEvent(new CustomEvent('oninput', {}));
            }
        }
    }

    setDefaultIntervalButton() {
        const selectedInterval = this.getSubscriptionPlan();
        if (selectedInterval) {
            const intervalButtons = document.querySelectorAll('.donation-interval-btn') as NodeList;
            for (let i = 0; i < intervalButtons.length; i++) {
                const intervalButton: HTMLInputElement = (intervalButtons[i] as HTMLInputElement);
                if (intervalButton.getAttribute('interval') === selectedInterval) {
                    this.setActiveIntervalButton(intervalButton);
                }
            }
        }
    }

    bindGiftButtonClickEvent(giftAmounts?: GiftAmount[], giftAmountClickCallback?: any) {
        if (giftAmounts && giftAmounts.length > 0) {
            const giftButtons = document.querySelectorAll('.gift-amount-btn') as NodeList;
            for (let i = 0; i < giftButtons.length; i++) {
                (giftButtons[i] as HTMLInputElement).onclick = (event: any) => {
                    giftAmountClickCallback(event);
                };
            }
        }
    }

    bindIntervalButtonClickEvent(intervalClickCallback?: any) {
        const intervalButtons = document.querySelectorAll('.donation-interval-btn') as NodeList;
        for (let i = 0; i < intervalButtons.length; i++) {
            (intervalButtons[i] as HTMLInputElement).onclick = (event: any) => {
                intervalClickCallback(event);
            };
        }
    }

    setActiveGiftAmountButton(giftAmountButtonElement: HTMLInputElement) {
        giftAmountButtonElement.classList.add('active');
    }

    removeActiveGiftAmountButton() {
        const giftButtons = document.querySelectorAll('.gift-amount-btn') as NodeList;
        for (let i = 0; i < giftButtons.length; i++) {
            (giftButtons[i] as HTMLInputElement).classList.remove('active');
        }
    }

    setActiveIntervalButton(intervalButtonElement: HTMLInputElement) {
        intervalButtonElement.classList.add('active');
    }

    removeActiveIntervalButton() {
        const intervalButtons = document.querySelectorAll('.donation-interval-btn') as NodeList;
        for (let i = 0; i < intervalButtons.length; i++) {
            (intervalButtons[i] as HTMLInputElement).classList.remove('active');
        }
    }

    getSubscriptionPlan(): string | null {
        const selectElement = document.querySelector('#dynamic-plan-interval') as HTMLSelectElement;
        if (selectElement) {
            const option = selectElement.options[selectElement.selectedIndex];
            return option ? option.value : null;
        }
        return null;
    }

    getPlanIntervalElement() {
        return document.querySelector('#dynamic-plan-interval') as HTMLSelectElement;
    }

    showError() {
        const donationErrorElement = this.getHtmlElement('#donation-error');
        donationErrorElement.innerHTML = Translations.DONATION_AMOUNT_INVALID;
    }

    minDonationError() {
        const mindonationErrorElement = this.getHtmlElement('#minDonation-error');
        mindonationErrorElement.style.display = 'inherit';
    }

    hideError() {
        if (this.isBuilder) {
            return;
        }
        const donationErrorElement = this.getHtmlElement('#donation-error');
        donationErrorElement.innerHTML = '';

        const mindonationErrorElement = this.getHtmlElement('#minDonation-error');
        mindonationErrorElement.style.display = 'none';
    }

    showForm() {
        this.donationFormContainer.style.display = 'initial';
    }

    hideForm() {
        this.donationFormContainer.style.display = 'none';
    }

}
